/*
 * Load Vue & Vue-Resource.
 *
 * Vue is the JavaScript framework used by our App.
 */
if (window.Vue === undefined) {
    window.Vue = require('vue');

    /**
     * Disable Vue Debug tools
     */
    Vue.config.debug = false;
    Vue.config.devtools = false;
}

require('vue-resource');

Vue.http.headers.common['X-CSRF-TOKEN'] = App.csrfToken;

/**
 * Load Promises library.
 */
window.Promise = require('promise');

/*
 * Load Underscore.js, used for map / reduce on arrays.
 */
if (window._ === undefined) {
    window._ = require('underscore');
}


/*
 * Load Sweetalert.
 */
if (typeof Swal !== 'undefined') {
window.swal = function() {
    const args = Array.prototype.slice.call(arguments);
    let options = {};
    let callback = null;

    if (args.length > 0 && typeof args[args.length - 1] === 'function') {
        callback = args.pop();
    }

    if (args.length === 1 && typeof args[0] === 'object') {
        options = Object.assign({}, args[0]);
    } else if (args.length > 0) {
        options.title = args[0];
        if (args.length > 1 && typeof args[1] === 'string') {
            options.text = args[1];
        }
        if (args.length > 2 && typeof args[2] === 'string') {
            options.icon = args[2];
        }
    }

    if (options && options.type) {
        options.icon = options.type;
        delete options.type;
    }
    if (options && options.html === true && options.text) {
        options.html = options.text;
        delete options.text;
    }
    if (options) {
        delete options.closeOnCancel;
        delete options.closeOnConfirm;
    }

    const promise = Swal.fire(options);

    if (typeof callback === 'function') {
        promise.then((result) => {
            callback(
                result.isConfirmed,
                result.isDismissed ? result.dismiss : null,
                result
            );
        });
    }

    return promise;
};

window.swal.close       = () => Swal.close();
window.swal.fire        = (o) => Swal.fire(o);
window.swal.showLoading = () => Swal.showLoading();
window.swal.hideLoading = () => Swal.hideLoading();
window.swal.isVisible   = () => Swal.isVisible();
}

/**
 * Define the App component extension points.
 */
//App.components = {
//    profileBasics: {},
//    teamOwnerBasics: {},
//    editTeamMember: {},
//    navDropdown: {}
//};

/**
 * Load the App form utilities.
 */
require('./../forms/bootstrap');



// WEBPACK FOOTER //
// ./resources/assets/js/core/bootstrap.js